import React, { Component } from "react";

class PaymentTerms extends Component {
  render() {
    return (
      <div className="flex-center-center" style={{ height: "500px" }}>
        <h3>Payment Terms of Service</h3>
      </div>
    );
  }
}

export default PaymentTerms;
